// @ts-nocheck

class PerfectForModal {
  constructor() {
    this.setupEvents();
  }

  setupEvents() {
    document.querySelectorAll('[data-perfect-for-open]').forEach((btn) => {
      btn.addEventListener('click', () => this.openModal(btn.dataset.perfectForOpen));
    });

    document.querySelectorAll('[data-perfect-for-modal]').forEach((dialog) => {
      dialog.querySelector('[data-perfect-for-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });
    });
  }

  openModal(id) {
    const dialog = document.getElementById(id);
    if (dialog) dialog.showModal();
  }
}

new PerfectForModal();
